/* Vault of Delights — turntable on hover.

   Attaches the sprite strip on first hover or keyboard focus, never at page load.
   Skipped entirely on touch (there is no hover to trigger it, and it would spend
   mobile data for nothing) and when the visitor asks for reduced motion. */
(function () {
  if (!window.matchMedia) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (window.matchMedia("(hover: none)").matches) return;

  function arm(host) {
    if (!host || host.dataset.vodSpinArmed) return;
    host.dataset.vodSpinArmed = "1";

    var src = host.getAttribute("data-vod-spin");
    if (!src) return;
    var frames = parseInt(host.getAttribute("data-vod-frames"), 10);
    if (!frames || frames < 2) frames = 36;

    var el = document.createElement("span");
    el.className = "vod-spin";
    el.setAttribute("aria-hidden", "true");
    el.style.setProperty("--vod-frames", frames);
    // See the CSS: only frames-1 steps land on exact frame boundaries.
    el.style.setProperty("--vod-steps", frames - 1);

    // Decode before revealing, otherwise the first hover flashes an empty box.
    var pre = new Image();
    pre.decoding = "async";
    pre.addEventListener("load", function () {
      el.style.backgroundImage = 'url("' + src + '")';
      host.appendChild(el);
      host.classList.add("vod-spin-ready");
    }, { once: true });
    pre.addEventListener("error", function () {
      host.dataset.vodSpinArmed = "";
    }, { once: true });
    pre.src = src;
  }

  document.addEventListener("mouseover", function (e) {
    var host = e.target.closest && e.target.closest("[data-vod-spin]");
    if (host) arm(host);
  }, { passive: true });

  document.addEventListener("focusin", function (e) {
    var card = e.target.closest && e.target.closest(".card, .card-wrapper");
    if (!card) return;
    var host = card.querySelector("[data-vod-spin]");
    if (!host) return;
    arm(host);
    host.classList.add("vod-spin-focus");
  });

  document.addEventListener("focusout", function (e) {
    var card = e.target.closest && e.target.closest(".card, .card-wrapper");
    if (!card) return;
    var host = card.querySelector("[data-vod-spin]");
    if (host) host.classList.remove("vod-spin-focus");
  });
})();
